import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { ExpensesSummary } from './ExpensesSummary';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useCreditAgreementStore } from '~/core/routes/settings/implementations/common/CreditAgreementProvider/CreditAgreementProvider';

const RouteBase = () => {
  const isCreditAgreementLoaded = useCreditAgreementStore((store) =>
    Boolean(store.creditAgreement),
  );

  return (
    <Skeleton isLoaded={isCreditAgreementLoaded}>
      {isCreditAgreementLoaded && <ExpensesSummary />}
    </Skeleton>
  );
};

export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings/implementations" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
